module.exports = __webpack_public_path__ + "static/media/origami8.12b96023.jpg";